<template>
  <router-suspense-resolver>
    <template v-slot>
      <slot />
    </template>

    <template v-slot:preloader>
      <slot name="preloader" />
    </template>
  </router-suspense-resolver>
</template>

<script setup lang="ts">
import RouterSuspenseResolver from '@/components/resolvers/RouterSuspenseResolver.vue'
</script>
